/* ==========================================================================
   SUOT — Formato Titulo en los titulos de las tarjetas de producto (Claude)
   Convierte cualquier titulo (MAYUSCULAS, minusculas o Mixto) a
   "Primera Letra De Cada Palabra En Mayuscula", de forma uniforme, solo
   para lo que se muestra en el grid. NO modifica los datos del producto.
   Se re-aplica cuando el grid cambia (filtros, paginacion, scroll infinito).
   ========================================================================== */
(function () {
  var SEL = '.product-card-wrapper .card__heading a';

  // Las palabras que ya vienen enteras en MAYUSCULAS (XL, XS, MET...) se
  // respetan tal cual; al resto se le aplica el formato Titulo.
  function capWord(w) {
    return w.toLowerCase().replace(/(^|[\-\/])(\S)/g, function (m, p1, p2) {
      return p1 + p2.toUpperCase();
    });
  }

  function titleCase(str) {
    return str.split(/(\s+)/).map(function (w) {
      if (/\S/.test(w) && /\p{Lu}/u.test(w) && w === w.toUpperCase()) return w;
      return capWord(w);
    }).join('');
  }

  function process(node) {
    if (!node || node.nodeType !== 1) return;
    var els = node.matches && node.matches(SEL)
      ? [node]
      : (node.querySelectorAll ? node.querySelectorAll(SEL) : []);
    for (var i = 0; i < els.length; i++) {
      var a = els[i];
      var current = a.textContent.replace(/\s+/g, ' ').trim();
      if (!current) continue;
      var next = titleCase(current);
      if (a.textContent.trim() !== next) a.textContent = next;
    }
  }

  function run() { process(document.body || document.documentElement); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  try {
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) process(added[j]);
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
